import { Icon, Typography } from '@themenu/design-system'
import { Authorize } from 'components/Authorize/Authorize'
import { MenuSection } from './components/MenuSession'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { useSessionStore } from 'store/session'
import { mountMenuList } from 'utils/mountMenuList'
import { usePartners } from 'providers/swileMais/usePartners'

export const Menu = () => {
  const { route } = useRouter()
  const pathIsHome = route === '/'

  const {
    user: { corporate }
  } = useSessionStore()

  const { data: partners } = usePartners()

  const hasPartnersEnabled = Boolean(partners?.length)

  const swileCreditEnabled = !!corporate?.data?.swileCreditEnabled
  const menu = mountMenuList(swileCreditEnabled, hasPartnersEnabled)

  return (
    <nav className="grid gap-12">
      <Link
        className={`flex items-center gap-12 px-14 py-8 hover:bg-background-default rounded-8
            ${pathIsHome ? 'bg-background-default' : ''}`}
        href="/"
      >
        <Icon
          name="home"
          size={16}
          className={`mb-[2px] ${
            pathIsHome
              ? 'svg-children:stroke-content-primary svg-children:fill-content-primary'
              : ''
          }`}
        />
        <Typography
          variant="callout"
          className={pathIsHome ? 'text-content-primary' : ''}
        >
          Home
        </Typography>
      </Link>

      {menu.map(({ session_name, session_permissions, session_groups }) => (
        <Authorize key={session_name} permissions={session_permissions}>
          <MenuSection
            session_name={session_name}
            session_permissions={session_permissions}
            session_groups={session_groups}
          />
        </Authorize>
      ))}
    </nav>
  )
}
